import React, { useEffect, useState } from "react";
import DLEParetoChart from "./DLEParetoChart";
import DLERunChart from "./DLERunChart";
import AsyncCallHandler from "../../../common/AsyncCallHandler";
import NEXUS_CONST from "../../../common/constants";
import DailyInput from "./DailyInput";
import moment from "moment";
import RadioGroup from "devextreme-react/radio-group";
import DateBox from "devextreme-react/date-box";
import { exportOPHData } from "../../../actions/oph";
import { useSelector } from "react-redux";

export default ({ siteId, tierId, title, dleFlag, andon, navigationOn }) => {
  const [showExportForm, setShowExportForm] = useState(false);
  const [exportFilter, setExportFilter] = useState(0);
  const [sDate, setSDate] = useState(new Date());
  const [eDate, setEDate] = useState(new Date());
  const [dleRunChartData, setDLERunChartData] = useState([{}]);
  const [showDInput, setDInput] = useState(false);
  const [ophDate, setOPHDate] = useState(new Date());
  const [dleTarget, setDLETarget] = useState(0);
  const addBtnhndlr = () => setDInput(true);
  const isLightMode = useSelector((state) => state.theme.lightMode);

  const onExporting = () => {
    let startDate = moment(sDate).format("YYYY-MM-DD"),
      endDate = moment(eDate).format("YYYY-MM-DD");
    let inputData = {
      tierID: tierId,
      startDate: startDate,
      isall: exportFilter == 2 ? false : true,
      endDate: endDate,
      section: navigationOn,
    };
    exportOPHData("DLE Export", `dle/exportDLEData`, inputData);
  };

  useEffect(() => {
    if (!showDInput) {
      AsyncCallHandler(
        NEXUS_CONST.GET_DLE_RUN_CHART_DATA +
          "TierId=" +
          tierId +
          "&Date=" +
          moment(ophDate).format("YYYY-MM-DD"),
        NEXUS_CONST.GET
      ).then((res) => {
        setDLERunChartData(res.data);
        andon();
      });
    }
  }, [showDInput]);
  useEffect(() => {
    if (!showDInput) {
      AsyncCallHandler(
        "DLE/getDLETargetData?" +
          "tierId=" +
          tierId +
          "&date=" +
          moment(ophDate).format("YYYY-MM-DD"),
        NEXUS_CONST.GET
      ).then((res) => {
        setDLETarget(res.data.dleTarget);
      });
    }
  }, [showDInput]);
  return (
    <div className="col" style={{ margin: "0px" }}>
      <div className="col-heading">
        {title}
        <span className={dleFlag}></span>
      </div>

      <div className="col-body">
        <div className="create-posts" style={{ marginTop: "-54px" }}>
          <span
            onClick={() => {
              setShowExportForm(!showExportForm);
            }}
          >
            <i className="fas fa-file-export"></i>Export
          </span>
        </div>

        <span
          className="add-dle-btn"
          style={{ marginRight: "55px", fontSize: "20px" }}
        >
          <span>{`Target ${dleTarget} % `}</span>
        </span>

        <span className="add-dle-btn" onClick={addBtnhndlr}>
          <i className="fas fa-plus-circle"></i>
        </span>

        {showExportForm && (
          <div className="m-w-572" style={{ width: "100%", maxWidth: "100%" }}>
            <div>
              <RadioGroup
                items={[
                  { id: 0, text: "All" },
                  { id: 2, text: "Date range" },
                ]}
                value={exportFilter}
                valueExpr="id"
                displayExpr="text"
                onValueChanged={(e) => setExportFilter(e.value)}
                layout="horizontal"
              />
            </div>
            <div
              className="d-flex"
              style={{
                alignItems: "flex-end",
                flexWrap: "wrap",
                width: "100%",
                padding: "10px",
              }}
            >
              {exportFilter == 2 && (
                <div className="alert-container">
                  <span>
                    Start date:{" "}
                    <DateBox
                      value={sDate}
                      onValueChanged={(e) => setSDate(e.value)}
                      useMaskBehavior={true}
                      type="date"
                    />
                  </span>
                  <span style={{ marginLeft: "10px" }}>
                    End date:{" "}
                    <DateBox
                      value={eDate}
                      onValueChanged={(e) => setEDate(e.value)}
                      type="date"
                      useMaskBehavior={true}
                    />
                  </span>
                </div>
              )}
              <div className="cbtn d-flex justify-space-between align-items-center">
                <button
                  onClick={(e) => onExporting(e)}
                  className="btn secondary-btn"
                >
                  Export
                </button>
                <button
                  onClick={() => {
                    setShowExportForm(!showExportForm);
                  }}
                  className="btn primary-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="col-body">
        <DLERunChart
          tierId={tierId}
          dleRunChart={dleRunChartData}
        ></DLERunChart>
      </div>
      <div className="col-body">
        <DLEParetoChart tierId={tierId} showDInput={showDInput}></DLEParetoChart>
      </div>
      {showDInput && (
        <DailyInput
          tierId={tierId}
          siteId={siteId}
          closeDI={() => setDInput(false)}
          navigationOn={navigationOn}
        />
      )}
    </div>
  );
};
